import React from 'react';
import { useRouter } from 'next/router';

interface NoHoverPrefetchAnchorProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

const NoHoverPrefetchAnchor: React.FC<NoHoverPrefetchAnchorProps> = ({
  href,
  children,
  className,
  style,
  onClick,
}) => {
  const router = useRouter();

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault(); // Prevent default anchor behavior
    if (onClick) {
      onClick(event); // Call custom onClick handler if provided
    }
    router.push(href); // Use Next.js router to navigate
  };

  return (
    <a
      href={href}
      className={className}
      style={style}
      onClick={handleClick}
      // Disable prefetching by not using the `next/link` component
    >
      {children}
    </a>
  );
};

export default NoHoverPrefetchAnchor;
